import { CommonModule } from '@angular/common';
import { Component, Input, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogContentBase, DialogRef, DialogsModule, WindowModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CasiCloseOptions } from '../../common/constants.lib';
import { LoggerService } from '../../shared/logger.service';

@Component({
  selector: 'casi-confirm-modal',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    InputsModule,
    ButtonsModule,
    DialogsModule,
    WindowModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss'
})
export class ConfirmModalComponent  extends DialogContentBase implements OnInit{

  private _title: string = 'Abandon Changes';
  private _content: string = 'Abandon your changes?';

  @Input({ required: true })
  set title(value: string) {
    this._title = value;
  }
  get title(): string | undefined {
    return this._title
  };

  @Input({ required: true })
  set content(val: string) {
    this._content = val;
  }
  get content() {
    return this._content;
  }

  @Input() okText: string = 'OK';
  @Input() cancelText: string = 'Cancel';

  constructor(
    public override dialog: DialogRef,
    private logger: LoggerService,
  ) {
    super(dialog);
  }

  //#region Ng Events

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  //#endregion

  public cancelClose(): void {
    this.logger.debug(`cancelClose...`);
    this.dialog.close({ text: CasiCloseOptions.Closed });
  }

  public confirmClose(): void {
    this.dialog.close({ text: CasiCloseOptions.Ok });
  }

}
